import React from "react";
import { TextField, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import { checkField, updateField } from "features/doctypesSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "services/store";
import { setOcrData } from "features/appStateSlice";

interface NumberFieldProps {
  field: any;
  doctypeKey: string;
  inputRef?: React.Ref<HTMLInputElement>;
  onBlurOcr: any;
  focusIndex: number;
}

const NumberField: React.FC<NumberFieldProps> = ({
  field,
  doctypeKey,
  inputRef,
  onBlurOcr 
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const ocrData = useSelector((state: RootState) => state.appState.ocrData);
    const check = () => { dispatch(checkField({ doctypeKey, fieldKey: field.Key })); };

    const formatValue = (value: string) => {
      if (value) {
        return parseFloat(value).toFixed(2);
      }
      return "";
    };

    const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
    
      if (/^-?\d*\.?\d*$/.test(newValue)) {
        dispatch(
          updateField({
            doctypeKey,
            fieldProperty: "InputValue",
            fieldKey: field.Key,
            value: newValue,
          })
        );
        dispatch(
          updateField({
            doctypeKey,
            fieldProperty: "Value",
            fieldKey: field.Key,
            value: newValue,
          })
        );

        if(ocrData?.lastOcrTemplatePage) {
          let newOcrData = structuredClone(ocrData);
          if(newOcrData.lastOcrTemplatePage) {
            newOcrData.lastOcrTemplatePage = undefined;
            dispatch(setOcrData(newOcrData));
          }
        }
      }
    };

    const handleNumberBlur = () => {
      const formattedValue = formatValue(field.Value || "");
      dispatch(
        updateField({
          doctypeKey,
          fieldProperty: "InputValue",
          fieldKey: field.Key,
          value: formattedValue,
        })
      );
      dispatch(
        updateField({
          doctypeKey,
          fieldProperty: "Value",
          fieldKey: field.Key,
          value: formattedValue,
        })
      );
      check();

      if(ocrData?.lastOcrTemplatePage) {
        let newOcrData = structuredClone(ocrData);
        if(newOcrData.lastOcrTemplatePage) {
          newOcrData.lastOcrTemplatePage = undefined;
          dispatch(setOcrData(newOcrData));
        }
      }

      if(onBlurOcr) {
        onBlurOcr(field);
      }
    };

    return (
      <FormControl fullWidth>
        <TextField
        inputRef={inputRef}
          type="text"
          variant="standard"
          label={field.Label}
          required={field.Required}
          error={field.Error !== undefined && field.Error !== null}
          helperText={t(field.Error) || ""}
          value={field.InputValue || ""}
          onChange={handleNumberChange}
          onBlur={handleNumberBlur}
          placeholder="0.00"
        />
      </FormControl>
    );
  }

export default NumberField;
